import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import all from 'prop-types-extra/lib/all';
import * as React from 'react';
import { useContext } from 'react';
import { useUncontrolled } from 'uncontrollable';
import BaseNav from '@restart/ui/Nav';
import { useBootstrapPrefix } from './ThemeProvider';
import NavbarContext from './NavbarContext';
import CardHeaderContext from './CardHeaderContext';
import NavItem from './NavItem';
import NavLink from './NavLink';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  justify: false,
  fill: false
};
var Nav =
/*#__PURE__*/
React.forwardRef(function (uncontrolledProps, ref) {
  var _classNames;

  var _useUncontrolled = useUncontrolled(uncontrolledProps, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      initialBsPrefix = _useUncontrolled.bsPrefix,
      variant = _useUncontrolled.variant,
      fill = _useUncontrolled.fill,
      justify = _useUncontrolled.justify,
      navbar = _useUncontrolled.navbar,
      navbarScroll = _useUncontrolled.navbarScroll,
      className = _useUncontrolled.className,
      activeKey = _useUncontrolled.activeKey,
      props = _objectWithoutProperties(_useUncontrolled, ["as", "bsPrefix", "variant", "fill", "justify", "navbar", "navbarScroll", "className", "activeKey"]);

  var bsPrefix = useBootstrapPrefix(initialBsPrefix, 'nav');
  var navbarBsPrefix;
  var cardHeaderBsPrefix;
  var isNavbar = false;
  var navbarContext = useContext(NavbarContext);
  var cardHeaderContext = useContext(CardHeaderContext);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    cardHeaderBsPrefix = cardHeaderContext.cardHeaderBsPrefix;
  }

  return (
    /*#__PURE__*/
    _jsx(BaseNav, _objectSpread({
      as: as,
      ref: ref,
      activeKey: activeKey,
      className: classNames(className, (_classNames = {}, _defineProperty(_classNames, bsPrefix, !isNavbar), _defineProperty(_classNames, "".concat(navbarBsPrefix, "-nav"), isNavbar), _defineProperty(_classNames, "".concat(navbarBsPrefix, "-nav-scroll"), isNavbar && navbarScroll), _defineProperty(_classNames, "".concat(cardHeaderBsPrefix, "-").concat(variant), !!cardHeaderBsPrefix), _defineProperty(_classNames, "".concat(bsPrefix, "-").concat(variant), !!variant), _defineProperty(_classNames, "".concat(bsPrefix, "-fill"), fill), _defineProperty(_classNames, "".concat(bsPrefix, "-justified"), justify), _classNames))
    }, props))
  );
});
Nav.displayName = 'Nav';
Nav.defaultProps = defaultProps;
export default Object.assign(Nav, {
  Item: NavItem,
  Link: NavLink
});